(function () {
    'use strict';

    angular.module('UndergroundWebApp').controller('BatteryTypeController', BatteryTypeController);

    BatteryTypeController.$inject = [
        '$q',
        '$scope',
        '$rootScope',
        'filterStateService',
        '$translate',
        'batteryTypeService',
        'formTypes',
        'statusOptions',
        'deviceService',
        '$kWindow',
    ];

    function BatteryTypeController(
        $q,
        $scope,
        $rootScope,
        filterStateService,
        $translate,
        batteryTypeService,
        formTypes,
        statusOptions,
        deviceService,
        $kWindow,
        ) {

        $scope.deleteBatteryType = deleteBatteryType;
        $scope.openUpdateBatteryTypeModal = openUpdateBatteryTypeModal;
        $scope.openNewFraction = openNewFraction;

        $scope.batteryTypeGridOptions = {
            dataSource: new kendo.data.DataSource({
                transport: {
                    read: readBatteryTypes
                },
                pageSize: 10,
                sort: filterStateService.getSortFromQueryString(),
                filter: filterStateService.getFilterFromQueryString(),
            }),
            columns: [
                { field: 'name', title: $translate.instant('G_NAME') },
                { field: 'minimumVoltage', title: $translate.instant('ADMINISTRATION_BATTERY_TYPE_MINIMUM_VOLT') },
                { field: 'maximumVoltage', title: $translate.instant('ADMINISTRATION_BATTERY_TYPE_MAXIMUM_VOLT') },
                { field: 'capacity', title: $translate.instant('ADMINISTRATION_BATTERY_TYPE_CAPACITY') },
                {
                    field: 'edit',
                    filterable: false,
                    sortable: false,
                    groupable: false,
                    title: ' ',
                    width: '80px',
                    template: '<i class="fa fa-1-5x fa-pencil fa-fw" ng-click="openUpdateBatteryTypeModal(dataItem)" aria-hidden="true"></i>' +
                        '<i class="fa fa-1-5x fa-trash fa-fw" ng-click="deleteBatteryType(dataItem)" aria-hidden="true"></i>'
                }
            ],
            scrollable: {
                virtual: true
            },            
            sortable: true,
            language: "english",
            filterable: true,
            noRecords: true,            
            resizable: true,
            selectable: false,
            sort: filterStateService.storeGridSortInQueryString,
            filter: filterStateService.storeGridFilterInQueryString,
        };

        function readBatteryTypes(e) {
            $scope.showBusyIndicator();
            batteryTypeService.getBatteryTypes().then(result => {
                $scope.batteryTypes = result;
                $scope.hideBusyIndicator();
                e.success($scope.batteryTypes)
            },
            function () {
                $scope.hideBusyIndicator();
                e.success([]);
            });
        }

        function openNewFraction() {
            openBatteryTypeModal($translate.instant('ADMINISTRATION_BATTERY_TYPE'), formTypes.add)
                .result.then(function() { });
        }

        function openUpdateBatteryTypeModal(dataItem) {
            openBatteryTypeModal($translate.instant('ADMINISTRATION_BATTERY_TYPE'), formTypes.edit, dataItem)
                .result.then(function () { });
        }

        function deleteBatteryType(dataItem) {           
            deviceService.getDevices()
            .then(devices => {
                const devicesWithBatteryToBeDeleted = devices.filter(device => device.batteryTypeId === dataItem.id);
                if (devicesWithBatteryToBeDeleted.length > 0) {
                    const confirmText = $translate.instant('ADMINISTRATION_BATTERY_TYPE_DIALOG_CANNOT_DELETE_WITH_DEVICES_IN_USE') 
                    + ' ' 
                    + devicesWithBatteryToBeDeleted.map(device => device.externalId).join(', ') + '?';
                    alert($translate.instant(confirmText));
                    return;
                }else{
                    const confirmText = $translate.instant('ADMINISTRATION_BATTERY_TYPE_DIALOG_CONFIRM_DELETE');

                    if (confirm(`${confirmText} ${dataItem.name}?`)) {
                        dataItem.status = statusOptions.deleted.Id;
                        batteryTypeService.updateBatteryType(dataItem).then(() => {
                            $('#batteryTypeGrid').getKendoGrid().dataSource.read();
                        });
                    }
                }
            });            
        }

        function openBatteryTypeModal(title, formType, batteryType) {
            return $kWindow.open({
                options: {
                    modal: true,
                    movable: false,
                    title: title,
                    resizable: false,
                    height: 465,
                    width: 410,
                    visible: false
                },
                templateUrl: 'app/administration/batteryType/battery-type-details-modal-view.html',
                windowTemplateUrl: 'app/shared/modal-base.html',
                controller: 'BatteryTypeDetailsModalController',
                resolve: {
                    currentFormType: () => formType,
                    batteryType: () => batteryType
                }
            });
        }

    }
})();
